// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"JJ-z","smallCardRow":"KJ-z","largeCardRow":"LJ-z","productSearchRow":"MJ-z","curatedRow":"NJ-z"};